import { useEffect, useState } from 'react';
import CortevaDashboard from './corteva';
import CommonDashboard from './common';
import GreenplyDashboard from './greenply';
import CortevaGalileoDashboard from './corteva-galileo';
import { getProjectByLocal, goToLink } from '../projectData';
import { useNavigate } from 'react-router-dom';
import { LuckyDrawDashboard } from './lucky-draw';
import { useRouteData } from '../RouteDataContext';
import { getUserToken } from '../api';
import TermsConditionHome from '../term&condition/termsConditionHome';
import { FullPageLoader } from '../../component/helper';
import FmcAksyaPatraraDashboard from './fmcAksyaPatraraDashboard';
import KycWithoutLoginDashboard from './KYCWithoutLogin';
//goToLink(navigate, '/customer/scheme-dashboard', [])
// Mapping JSON component names to React components
const components = {
    'CortevaGalileoDashboard': CortevaGalileoDashboard,
    'CommonDashboard': CommonDashboard,
    'CortevaDashboard': CortevaDashboard,
    'LuckyDrawDashboard': LuckyDrawDashboard,
    'GreenplyDashboard': GreenplyDashboard,
    'FmcAksyaPatraraDashboard': FmcAksyaPatraraDashboard,
    'KycWithoutLoginDashboard': KycWithoutLoginDashboard,
};

/**
 * DynamicDashboard component renders the appropriate dashboard based on project and user data.
 * Handles privacy policy status, loading state, and conditional rendering of dashboards or terms.
 */
const DynamicDashboard = () => {
    const { userData } = useRouteData();

    const navigate = useNavigate()
    const projectData = getProjectByLocal();
    const [privacyStatus, setPrivacyStatus] = useState('yes')
    const [loading, setLoading] = useState(true); // Loader state
    useEffect(() => {

        const fetchProjectData = async () => {
            try {
                const tokenResponse = await getUserToken({
                    user_mobile: userData?.user?.phone,
                    project_key: projectData.pkey,
                });
                const token = tokenResponse?.data;
                if (!token) throw new Error("Token not found in response");

                //setPrivacyStatus(projectResponse?.data?.communicationType?.privacy_policy_status);

            } catch (error) {
                console.error("Error fetching project data:", error);
            } finally {
                setLoading(false); // Stop loading once done
            }
        };

        if (projectData && userData) {
            if (projectData?.trem_condition) {
                fetchProjectData();
            } else {
                setLoading(false)
            }
        }

    }, [projectData, userData]);
    const ComponentToRender = components[projectData?.dashboardName];
    if (loading) {
        return <FullPageLoader />;
    }
    if (!ComponentToRender) {

        return <div className='container vh-100'>
            <div className="d-flex flex-column align-items-center  p-2 mt-6" style={{ backgroundColor: "#fff" }}>
                <div className='d-flex justify-content-center'>
                    <img src={`/media/auth/error.png`} className="" alt="" style={{ width: '150px', height: '150px' }} />
                </div>

                <div style={{ border: '1px solid #dadada' }} className="card card-flush w-lg-650px">
                    <div style={{ background: '#FBF6F7', minHeight: '39px' }} className="card-header p-3">
                        <div style={{ color: '#FF4141' }} className="card-title">Refersh</div>
                    </div>
                    <div className="card-body p-3">
                        <div style={{ color: '#000' }} className="fs-6">
                            If you're having trouble with your authentication credentials, please click on refresh button.
                        </div>
                        <div className='d-flex mt-2 align-item-center'>
                            <button className='btn btn-danger' onClick={() => goToLink(navigate, '/customer/dashboard', [])}>Refresh</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    }
    return (
        <>
            {projectData?.trem_condition ? (
                privacyStatus === "yes" ? (
                    <ComponentToRender projectData={projectData} />
                ) : (
                    <TermsConditionHome ckey={projectData?.ckey} setPrivacyStatus={setPrivacyStatus} />
                )
            ) : (
                <ComponentToRender projectData={projectData} />
            )}
        </>
    );
};

export default DynamicDashboard;
